import script from "./jiekou.vue?vue&type=script&setup=true&lang=ts"
export * from "./jiekou.vue?vue&type=script&setup=true&lang=ts"

import "./jiekou.vue?vue&type=style&index=0&id=5e83bc42&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e83bc42"]])

export default __exports__